export interface ProviderOutputApiModel{
    provider: string
}

export interface LoadSSOOutputApiModel{
    [key: string]: ProviderOutputApiModel
}

export interface LoadAppSettingOutputApiModel{
    sso_domains: LoadSSOOutputApiModel,
    social_domains: string[]
}